import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import Spinner from '../../assets/Spinner.svg';

import './Loader.scss';

type LoaderProps = {
    loading: boolean
    rtl: boolean
}

function Loader({ loading, rtl }: LoaderProps) {
    const { t } = useTranslation();

    if (!loading) return null;
    return (
        <div className={rtl ? 'ECloader-container ECLoaderArabic' : 'ECloader-container'}>
            <div className='ECloader'>
                <Typography >{t('loading')}...</Typography>
                <img src={Spinner} alt='spinner' />
            </div>
        </div>
    )
}

export default Loader